import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export const NumFavs = withDefaultIconProps(
  {
    height: 21,
    width: 22,
    color: theme.colors['surface.tertiary'],
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 22 21">
      <Path
        d="M4.87 11.84L10.28 16.89C10.55 17.14 10.89 17.27 11.24 17.27C11.58 17.27 11.93 17.14 12.2 16.89L17.61 11.84C18.46 11.04 18.94 9.96 18.95 8.79C18.96 7.67 18.53 6.6 17.73 5.8C16.93 4.99 15.88 4.55 14.75 4.54C14.75 4.54 14.74 4.54 14.73 4.54C13.83 4.54 12.98 4.82 12.25 5.35C11.85 5.64 11.51 5.99 11.24 6.39C10.97 5.99 10.63 5.64 10.23 5.35C9.5 4.82 8.63 4.54 7.73 4.54C6.6 4.55 5.54 4.99 4.75 5.8C3.95 6.6 3.52 7.67 3.53 8.79C3.54 9.96 4.01 11.04 4.87 11.84H4.87ZM5.51 6.55C6.1 5.95 6.89 5.61 7.73 5.61C7.74 5.61 7.74 5.61 7.75 5.61C8.42 5.61 9.06 5.82 9.6 6.21C10.13 6.6 10.52 7.14 10.73 7.76C10.8 7.98 11.01 8.13 11.24 8.13C11.47 8.13 11.67 7.98 11.75 7.76C11.95 7.14 12.35 6.6 12.88 6.21C13.42 5.82 14.06 5.61 14.73 5.61C14.74 5.61 14.74 5.61 14.75 5.61C15.59 5.61 16.38 5.95 16.97 6.55C17.56 7.15 17.89 7.94 17.88 8.78C17.87 9.65 17.52 10.46 16.88 11.06L11.47 16.11C11.34 16.23 11.14 16.23 11.01 16.11L5.6 11.06C4.96 10.46 4.61 9.65 4.6 8.78C4.59 7.94 4.92 7.15 5.51 6.55Z"
        fill={color}
      />
    </Svg>
  ),
);
